import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PorteBeneficiario } from 'src/app/model/porte-beneficiario-model';

@Component({
    selector: 'app-porte-beneficiario-listagem',
    templateUrl: './porte-beneficiario-listagem.component.html',
    styleUrls: ['./porte-beneficiario-listagem.component.scss'],
    standalone: false
})
export class PorteBeneficiarioListagemComponent implements OnInit, OnChanges {

  @Input() public portes: PorteBeneficiario[] = [];
  @Input() public atributosPaginacao: EntityPagedRequestParameters

  public opcoesPaginacao: number[];
  public listaPorte: PorteBeneficiario[];
  public countPortes: number;

  constructor() { }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0]
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.navegar(this.atributosPaginacao)
  }

  public mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.navegar(this.atributosPaginacao)
  }

  public navegar(pesq: EntityPagedRequestParameters) {
    let posInicial: number, posFinal: number;

    posInicial = (pesq.page - 1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.portes.length) {
      posFinal = this.portes.length
    }

    this.listaPorte = this.portes.slice(posInicial, posFinal)
    this.countPortes = this.portes.length
  }

}
